import styled from '@emotion/styled';

const Subtitle = styled('div')(({ theme }) => ({
  color: theme.colors.gray['400'],
  a: {
    color: theme.colors.gray['400'],
  },
}));

export default Subtitle;
